<template>
    <div>
        <navbar1></navbar1>
        <div class="__buildbg">
            <div class="container">
                <div class="row">
                    <div class="col-lg-7 col-md-9 col-sm-9">
                        <p class="__welf1">Hire from our network<br> of pre-vetted tech talents</p>
                        <p class="__welf2">Fill the form below and we will reach you shortly</p>
                    </div>
                    <div class="col-lg-5 col-md-3 col-sm-3"></div>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="__form-wrap ">
                <form @submit.prevent="checkForm" action="/" method="post">
                    <div class="row">
                        <div class="col-lg-5 col-md-4 col-sm-4">
                            <p class="__hirep">Select your talents</p>
                            <!-- <p class="__hirep1">We understand how critical talent is to the <br />success of any organization. Therefore, we</p> -->
                            <div class="__selcard">
                                <div class="form-group">
                                    <label for="work-time">Select more than one</label>

                                        <div class="__radio-wrap">
                                        <div>
                                            <label class="check">
                                                UX & product designer
                                                <input
                                                class="form-control"
                                                type="checkbox"
                                                name="is_name"
                                                data-field="general"
                                                />
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                        <div>
                                            <label class="check">
                                                Front end developer
                                                <input
                                                class="form-control"
                                                type="checkbox"
                                                name="is_name"
                                                data-field="general"
                                                />
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                        <div>
                                            <label class="check">
                                                Back end developer
                                                <input
                                                class="form-control"
                                                type="checkbox"
                                                name="is_name"
                                                data-field="general"
                                                />
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                        <div>
                                            <label class="check">
                                                Project manager
                                                <input
                                                class="form-control"
                                                type="checkbox"
                                                name="is_name"
                                                data-field="general"
                                                />
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                        <div>
                                            <label class="check">
                                                Data scientist
                                                <input
                                                class="form-control"
                                                type="checkbox"
                                                name="is_name"
                                                data-field="general"
                                                />
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                        <div>
                                            <label class="check">
                                                VR/AR developers
                                                <input
                                                class="form-control"
                                                type="checkbox"
                                                name="is_name"
                                                data-field="general"
                                                />
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="projb">Salary budget</label>

                                    <input
                                    autofocus
                                    type="text"
                                    class="form-control __form-control"
                                    id="projb"
                                    name="projb"
                                    data-field="general"
                                    placeholder="N 000,000.00"
                                    />
                                </div>
                                
                                <!-- <div class="form-group">
                                    <label for="projb1">Project budget</label>

                                    <input
                                    autofocus
                                    type="text"
                                    class="form-control __form-control"
                                    id="projb1"
                                    name="projb1"
                                    data-field="general"
                                    placeholder="N 200,000.00"
                                    />
                                </div> -->
                            </div>
                        </div>
                        <div class="col-lg-7 col-md-8 col-sm-8">
                            <p class="__hirep">Let us know you</p>

                            <p class="__hirep1">We charge N30,000 as commitment fee and 10% of the talent's annual salary.</p>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label for="full-name">Full name</label>

                                        <input
                                        autofocus
                                        type="text"
                                        class="form-control __form-control"
                                        id="full-name"
                                        name="full-name"
                                        data-field="general"
                                        placeholder="John Jane Doe"
                                        />
                                    </div>
                                </div>

                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label for="email">Email</label>

                                        <input
                                        type="email"
                                        class="form-control __form-control"
                                        id="email"
                                        name="email"
                                        data-field="email"
                                        placeholder="address@yourdomain.com"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label for="phone">Phone number</label>
                                        <input
                                        type="tel"
                                        class="form-control __form-control"
                                        id="phone"
                                        name="phone"
                                        data-field="phone"
                                        placeholder="+234 812 345 6789"
                                        />
                                    </div>
                                </div>

                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label for="work-dur">Company</label>

                                        <input
                                        type="text"
                                        class="form-control __form-control"
                                        id="work-dur"
                                        name="work-dur"
                                        data-field="general"
                                        placeholder="Enter company name"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label for="level">Level</label>
                                        <select name="level" id="level" class="form-control __form-control" data-field="general">
                                            <option value="level" disabled="disabled"></option>Level</option>
                                            <option value="beginner">Beginner</option>
                                            <option value="intermediate">Intermediate</option>
                                            <option value="expert">Expert</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label for="contlink">Contact link or Skype ID</label>

                                        <input
                                        type="text"
                                        class="form-control __form-control"
                                        id="contlink"
                                        name="contlink"
                                        data-field="general"
                                        placeholder="Enter link or ID here"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="project-desc">Job description</label>

                                <textarea
                                class="form-control"
                                id="project-desc"
                                name="project-desc"
                                rows="5"
                                data-field="general"
                                placeholder="Type here"
                                ></textarea>
                            </div>

                            <div class="row">
                                <div class="col-lg-4 col-md-4 col-sm-6">
                                <button class="btn btn-block  __adjustlink ">Submit form</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <div class="__wedobg">
            <div class="container">
                <p class="__wedop">Why Our Pros?</p>
                <p class="__wedop1">We understand how critical talent is to the success of any organisation. Therefore, we ensure that we supply only the<br> right hands for your business.</p>
                <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-6">
                        <i class="__icon fas fa-palette"></i>
                        <p class="__hidep">A-list Only</p>
                        <p class="__hidep1">We supply a-list talents who love to be part of mission-critical projects.</p>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6">
                        <i class="__icon fas fa-palette"></i>
                        <p class="__hidep">Easy Communication</p>
                        <p class="__hidep1">We make sure all of our elite talents understand English clearly and are fluent.</p>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6">
                        <i class="__icon fas fa-palette"></i>
                        <p class="__hidep">No Maybes</p>
                        <p class="__hidep1">We understand the need for completion and excellence by enterprise clients.</p>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6">
                        <i class="__icon fas fa-palette"></i>
                        <p class="__hidep">Start Executing</p>
                        <p class="__hidep1">Focus on building the Nth version of your products by hiring from our network of PRO talents. </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="__midbg1">
            <div class="container">
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-9">
                        <p class="__ourp">Want to partner<br> with us?</p>
                        <p class="__ourp1">There are many ways we can work together,<br> There are other projects at Findworka. We<br> have the Saucecode community of talents, Findworka Fellowship for aspiring software engineers, Findworka Mentors for experienced software instructors and the annual Saucecode Hackathons</p>
                    </div>
                    <div class="col-lg-8 col-md-8 col-sm-12">
                        <div class="row">
                            <div class="col-lg-4 col-md-4 col-sm-4">
                                <router-link to="/academy"><div class="__impcard">
                                    <div class="__impimg"></div>
                                    <div class="__imppc">
                                        <p class="__impp">Findworka academy</p>
                                        <p class="__impp1">A fellowship programme for aspiring developers to receive training from first-rate developers.</p>
                                        <p class="__imppa">Visit page <img src="../assets/img/right-arrow.svg"></p>
                                    </div>
                                </div></router-link>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-4">
                                <a href="http://saucecode.xyz" target="blank"><div class="__impcard">
                                    <div class="__impimg1"></div>
                                    <div class="__imppc">
                                        <p class="__impp">Saucecode</p>
                                        <p class="__impp1">Our closely knit circle of techies, staying updated on tech trends and following gig alerts.</p>
                                        <p class="__imppa">Become an alpha <img src="../assets/img/right-arrow.svg"></p>
                                    </div>
                                </div></a>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-4">
                                <a href="https://pro.findworka.com/" target="blank"><div class="__impcard">
                                    <div class="__impimg2"></div>
                                    <div class="__imppc">
                                        <p class="__impp">Findworka PRO</p>
                                        <p class="__impp1">An elite network of pre-vetted designers and developers with competence and real-world experience.</p>
                                        <p class="__imppa">See events <img src="../assets/img/right-arrow.svg"></p>
                                    </div>
                                </div></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import navbar1 from "../components/navbar1";
export default {
  components: { navbar1 },
  data() {
    return {
      fields: {},
      template: {
        general: {
          exp: /./,
          msg: "Field cannot be blank"
        },
        phone: {
          exp: /^\d{7,}$/,
          msg:
            "Invalid phone number.Phone number must be 13 digits long and start with +234"
        },

        email: {
          exp: /^([a-z0-9\._]+)@{1}([a-z0-9\._]+)$/,
          msg:
            "Email must contain @ and should contain only letters, numbers, underscores and dots "
        }
      }
    };
  },
  mounted() {
    let fields = document.querySelectorAll(".form-control");
    let radios = document.querySelectorAll("[data-radio]");
    fields.forEach(f => {
      this.fields[f.name] = false;
    });

    if(radios.length > 0)
    {
         radios.forEach(r => {
        this.fields[r.name] = false;
        });
    }

    //console.log(this.fields);
  },
  methods: {
    checkForm(e) 
    {
      //get the form  
      const form = e.target;
      let canSubmit = true;

      for (const field in this.fields) 
      {
        //get field in form
        const input = form.querySelector(`[name="${field}"]`);

        switch (input.type) 
        {
            //for file input
          case "file":
            if (input.files.length > 0) {
              const file = input.files[0];
              this.fields[field] = true;
              canSubmit = canSubmit && this.fields[field];
            } else {
              this.fields[field] = false;
              this.displayError(input, true);
              canSubmit = canSubmit && this.fields[field];
            }
            break;

        //for checkbox input
          case "checkbox":
            let checkCount = 0;
            const checks = form.querySelectorAll(`[name="${field}"]`);

            checks.forEach(c => {
              if (c.checked) {
                checkCount += 1;
              }
            });
            if (checkCount < 1) {
              this.fields[field] = false;
              this.displayError(checks[0], false, true);
              canSubmit = canSubmit && this.fields[field];
            }
            break;
            //for radio input
          case "radio":
            let radios = form.querySelectorAll(`[name="${field}"]`);
            let none = true;

            for (let radio = 0; radio < radios.length; radio++) {
              if (radios[radio].checked) {
                none = false;
                this.fields[field] = true;
                canSubmit = canSubmit && this.fields[field];
                break;
              }
            }
            if (none) {
              this.displayError(radios[0], false, true);
            }

            break;
//for text area and select and normal text input
          default:
            const value = input.value
              .trim()
              .toString()
              .toLowerCase();
            const type = input.dataset.field;

            if (this.template[type].exp.test(value)) {
              this.fields[field] = true;
              canSubmit = canSubmit && this.fields[field];
            } else {
              this.fields[field] = false;
              this.displayError(input);
              canSubmit = canSubmit && this.fields[field];
            }

            break;
        }

      }
      console.log(this.fields);
     if(canSubmit)
    {
        this.submitForm(form);        
    } 

    },
    submitForm(form) {
      form.submit();
    },
    showFileName(e) {
      const input = e.target;
      const span = document.querySelector(".filename");

      if (input.files.length > 0) {
        const file = input.files[0];
        span.textContent = `${file.name}`;
      }
    },
    displayError(field, isFile = false, isMultiple = false) 
    { 

      if (isFile === true) //for file error
      {
        field.nextElementSibling.style.borderColor = "#f52f46";
        const label = field.previousElementSibling;
         label.style.color = "#f52f46";
      } 
      else if(isMultiple === true) //for radio or checkbox error, since html struture is basiaaly the same
      {
          const wrap = field.parentElement.parentElement.parentElement ;
          wrap.style.borderColor = "#f52f46";
          wrap.previousElementSibling.style.color = "#f52f46";
      }      
      else //all others
      {
         const label = field.previousElementSibling;
         label.style.color = "#f52f46";
         field.style.borderColor = "#f52f46";
      }


    }
  }
};
</script>

<style scoped>
@import '../assets/css/talent';
</style>


// WEBPACK FOOTER //
// src/components/talents.vue